export interface IAuthError {
  message: string;
}

export class AuthResponse {
  public readonly isValid: boolean;

  constructor(public errors: IAuthError[] = []) {
    this.isValid = !errors.length;
  }
}

export enum AdminRole {
  CSOperator = "CSOperator",
  Translator = "Translator",
  ContentAdmin = "ContentAdmin",
  SuperAdmin = "SuperAdmin",
}
